import { useRef, useState } from "react";
import Draggable, { DraggableEvent } from "react-draggable";
import { Offcanvas, OffcanvasBody } from "reactstrap";

const DraggableAny = Draggable as any;

const DraggableModal = ({
  isPaneOpen,
  togglePane,
  onClose,
  children,
  initHeight = 700,
}: any) => {
  const [height, setHeight] = useState<any>(initHeight); // Initial height of the Offcanvas
  const handleDrag: any = (e: DraggableEvent, data: any) => {
    setHeight((prevHeight: any) => prevHeight - data.deltaY);
  };
  const lastTap = useRef(0);
  const handleTouchStart = () => {
    const now = new Date().getTime();
    const delta = now - lastTap.current;

    if (delta < 300) {
      setHeight(400);
    }

    lastTap.current = now;
  };
  return (
    <Offcanvas
      backdrop={true}
      className={"chapterContentSlider"}
      isOpen={isPaneOpen}
      direction="bottom"
      toggle={togglePane}
      style={{
        height: height == "fit-content" ? `${height}` : `${height}px`,
        maxHeight: "calc(100dvh - 16px)",
      }}
      onClosed={onClose}
    >
      <DraggableAny
        axis="y"
        handle=".handle"
        onDrag={handleDrag}
        defaultClassName="draggableSlider"
      >
        <div
          className="handle"
          onTouchStart={handleTouchStart}
          onMouseDown={(e) => {
            e.preventDefault();
            document.addEventListener("mousemove", handleDrag);
            document.addEventListener("mouseup", () => {
              document.removeEventListener("mousemove", handleDrag);
            });
          }}
        >
          <span className="underScoreSpan"></span>
        </div>
      </DraggableAny>
      <OffcanvasBody className="p-0">{children}</OffcanvasBody>
    </Offcanvas>
  );
};
export default DraggableModal;
